import {
    Component,
    ElementRef,
    ViewChild,
    HostListener,
    OnInit,
    Output,
    EventEmitter,
  } from '@angular/core';
  import { debounceTime, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../../access/auth.service';
import { ModalService } from '../../util/modal.service';
import { IProductList, ProductDtoV2Response, ProductListFilter } from '../../models/product-v2';
import { ProductV2Service } from '../../pages/members/product-v2/services/product.v2.service';
  

  
  @Component({
    selector: 'app-product-search',
    templateUrl: './product-search.component.html',
    styleUrls: ['./product-search.component.scss']
  })
  export class ProductSearchComponent implements OnInit {
    searchTerm: string = '';
    filteredProducts: ProductDtoV2Response[] = [];
    showDropdown: boolean = false;
    hasSearched: boolean = false;

    errorFilterName = {
        error: ''
      }
      filterName = ''
  productListFilter!: ProductListFilter;
  products: IProductList[] = [];
  totalEl = 1
  @Output() productSelected = new EventEmitter<IProductList>();

  constructor(
      private readonly _route: Router,
      private readonly _service: ProductV2Service,
      private readonly _auth: AuthService,
      private readonly _modalService: ModalService,
    ) { }
    private searchSubject = new Subject<string>();
  
    @ViewChild('dropdownRef') dropdownRef!: ElementRef;
  
    ngOnInit(): void {
      this.searchSubject.pipe(debounceTime(500)).subscribe((term) => {
        this.fetchProducts(term);
      });
    }

  addProduct(product: IProductList): void {
    this.productSelected.emit(product);
    this.showDropdown = false;
    this.searchTerm = '';
    this.products = []; 
    this.hasSearched = false;
  }

    onSearchInput(): void {
      this.searchSubject.next(this.searchTerm.trim());
    }
    handleError(err) {
        if (err.status == 400) {
          this._modalService.showModalError('Ocurrio un error', 'Algunos caracteres no pudieron procesarse')
        } else {
          this._modalService.showModalGenerico(err)
        }
      }
    fetchProducts(term: string): void {
        this.errorFilterName.error = '';
        this.filterName = term; 
        this.productListFilter = {
          page: 0, 
          size: 10,
          q: term
        };

        this._service.list(this._auth.getStore().storeId, this.productListFilter).subscribe({
          next: (res: ProductDtoV2Response) => {
            this.setProducts(res);
            this.hasSearched = true; 

        },
          error: (err) => {
            this.handleError(err);
          }
        });
      }
      setProducts(res: ProductDtoV2Response) {
        if (res) {
          this.products = res.items
          this.totalEl = res.page.totalElements
          this.showDropdown = this.products.length > 0;
        }
      }
    
  
      @HostListener('document:click', ['$event'])
      onClickOutside(event: MouseEvent): void {
        const target = event.target;
      
        if (
          !this.dropdownRef ||
          !(target instanceof HTMLElement)
        ) {
          return;
        }
      
        if (!this.dropdownRef.nativeElement.contains(target)) {
          this.showDropdown = false;
        }
      }
  }
  
  